import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getReviewsAll, reviewsSelect } from 'redux-api/slices/reviewSlice';
import classes from './HomeReviews.module.scss';
import HomeSlider from './HomeSlider';


const getYoutubeId = (url = '') => {
  const match = url.match(/youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})|youtu\.be\/([a-zA-Z0-9_-]{11})/);
  return match ? match[ 1 ] || match[ 2 ] : null;
};

// Пока ролик не запущен, в карточке превью: iframe перехватывал мышь и касания,
// и ленту нельзя было потянуть за ролик. Плеер подгружается только по клику.
const ReviewVideo = ({ id, title }) => {
  const [ isPlaying, setIsPlaying ] = useState(false);

  if (isPlaying) {
    return (
      <iframe
        className={classes.video}
        src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0`}
        title={title}
        frameBorder="0"
        allow="autoplay; encrypted-media; picture-in-picture"
        allowFullScreen
      />
    );
  }

  return (
    <button type="button" className={classes.preview} onClick={() => setIsPlaying(true)} aria-label={title}>
      <img
        className={classes.previewImage}
        // Превью 16:9 без чёрных полей; если крупного нет — берём среднее.
        src={`https://i.ytimg.com/vi/${id}/maxresdefault.jpg`}
        onError={(event) => {
          const img = event.currentTarget;
          if (!img.src.includes('mqdefault')) img.src = `https://i.ytimg.com/vi/${id}/mqdefault.jpg`;
        }}
        alt=""
        loading="lazy"
        draggable={false}
      />
      <span className={classes.play} aria-hidden />
    </button>
  );
};

// wide — вариант страницы преимуществ: на мобильном карточка почти во всю ширину.
// items — свои отзывы (например, курса); без них грузим общий список.
const HomeReviews = ({ wide = false, items }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { reviews: allReviews } = useSelector(reviewsSelect);
  const reviews = items ?? allReviews;

  useEffect(() => {
    if (!items) dispatch(getReviewsAll());
    return () => null;
  }, [ dispatch, items ]);

  if (!reviews?.length) return null;

  return (
    <section className={`${classes.reviews} ${wide ? classes.reviewsWide : ''}`}>
      <div className={classes.container}>
        <HomeSlider title={t('StudentsFeedback')} trackClass={classes.track} slideClass={classes.slide}>
          {reviews.map((item, i) => {
            const id = getYoutubeId(item?.url);
            if (!id) return null;

            return (
              <div className={classes.card} key={id} data-aos="fade-up" data-aos-delay={(i % 3) * 100}>
                <ReviewVideo id={id} title={`Отзыв студента Geeks ${i + 1}`} />
              </div>
            );
          })}
        </HomeSlider>
      </div>
    </section>
  );
};

export default HomeReviews;
